import { FormDialogConfig, Icon } from '@aibees/shared/components';
import { formatString } from '@aibees/shared/utils';
import * as Yup from 'yup';
import { SearchFilter } from '../../types';
import { convertValueToArray } from './utils';

export function createScheme(items: SearchFilter[]) {
  const obj = items.reduce((acc, x) => {
    return {
      ...acc,
      [x.field!]: Yup.array()
        .transform((currentValue) => convertValueToArray(currentValue))
        .test('validator-custom-name', (value, { createError, path }) => {
          if ((value?.length ?? 0) > (x.metadata?.limit?.max?.size ?? 0))
            return createError({
              path,
              message: formatString(
                x.metadata?.limit?.max?.message ?? '',
                x.metadata?.limit?.max?.size.toString() ?? '',
                (
                  (value?.length ?? 0) - (x.metadata?.limit?.max?.size ?? 0)
                ).toString()
              ),
            });
          return true;
        }),
    };
  }, {});

  return Yup.object().shape(obj);
}

export function createConfig(items: SearchFilter[], filter?: SearchFilter) {
  const config: FormDialogConfig = {
    title: filter?.metadata?.dialog?.title,
    icon: <Icon name="search" size={20} color="primary" />,
    submitButtonProps: {
      children: 'Save and Search',
      size: 'small',
      variant: 'contained',
      color: 'primary',
    },
    closeButton: {
      children: 'Cancel',
      size: 'small',
      variant: 'text',
    },
    actionsPrepend: undefined,
  };
  config.scheme = createScheme(items);

  return config;
}
